var _defs, _path, _polygon, _polyline, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path2, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10105IconServiceContainerRegistries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e9f7ba73-56b8-4864-96ff-dce80bef729a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bdf27dc6-025c-4805-8bfd-3a05defd3fbd",
    x1: 8.637,
    y1: -1.991,
    x2: 8.637,
    y2: 16.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcd6c6c7-e2eb-4a32-b914-3a8485585a1b",
    x1: 12.96,
    y1: 8.561,
    x2: 12.96,
    y2: 6.141,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 20)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5a5c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43,8.178l2.589-1.573,7.255,2.731A3.664,3.664,0,0,0,16.23,7.49l-.01-.05A4.194,4.194,0,0,0,14,6.32a4.91,4.91,0,0,0-5.1-4.7A5.071,5.071,0,0,0,4.06,4.91,4.621,4.621,0,0,0,0,9.39a4.73,4.73,0,0,0,4.89,4.54H7.43Z",
    fill: "url(#bdf27dc6-025c-4805-8bfd-3a05defd3fbd)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10.07 7.159 10.08 11.439 17.99 13.119 17.99 10.139 10.07 7.159",
    fill: "#767676"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "10.07 7.159 7.93 8.459 7.93 12.439 10.08 11.439",
    fill: "#999"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.68 11.499 14.4 11.699 14.4 9.369 13.68 9.119 13.68 11.499",
    fill: "#a3a3a3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "12.96 8.889 12.24 8.629 12.24 11.119 12.96 11.319 12.96 8.889",
    fill: "#a3a3a3"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "15.12 11.889 15.82 12.079 15.84 9.859 15.12 9.619 15.12 11.889",
    fill: "#a3a3a3"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.81 10.749 11.53 10.929 11.53 8.399 10.81 8.159 10.81 10.749",
    fill: "#a3a3a3"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.27 10.349 16.55 10.099 16.55 12.269 17.27 12.469 17.27 10.349",
    fill: "#a3a3a3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ef0d1b54-a1e7-4cb9-a4e5-8a8518e7c127",
    d: "M8.66,11.369l-.36.21V8.749l.36-.19Zm.71-3.22L9,8.389v2.75l.37-.2Z",
    fill: "#b3b3b3"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.99 13.119 15.83 13.859 7.93 12.439 10.08 11.439 17.99 13.119",
    fill: "url(#fcd6c6c7-e2eb-4a32-b914-3a8485585a1b)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.99 16.169 10.04 17.679 10.08 12.089 17.99 13.559 17.99 16.169",
    fill: "#767676"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.81 16.759 10.81 13.209 11.53 13.299 11.53 16.639 10.81 16.759",
    fill: "#a3a3a3"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "12.96 16.399 12.24 16.529 12.24 13.389 12.96 13.499 12.96 16.399 12.96 16.399",
    fill: "#a3a3a3"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.68 16.289 13.68 13.569 14.4 13.659 14.4 16.159 13.68 16.289",
    fill: "#a3a3a3"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "15.83 15.909 15.12 16.039 15.12 13.749 15.83 13.859 15.83 15.909",
    fill: "#a3a3a3"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.29 15.679 16.55 15.809 16.55 13.929 17.24 14.019 17.29 15.679",
    fill: "#a3a3a3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "b9f25eb4-4c88-45c2-bc4d-f992757d7e0e",
    d: "M7.93,16.4v-3.26l2.16-1v5.6Z",
    fill: "#999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "eb9200a7-4693-4427-bdae-b33ce90ff7f2",
    d: "M8.61,16.389l-.32-.16v-2.76l.32-.15Zm.77-3.45-.38.19v3.48l.37.19v-3.86Z",
    fill: "#b3b3b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10105IconServiceContainerRegistries);
export default __webpack_public_path__ + "static/media/10105-icon-service-Container-Registries.e8dcfb9ab6f6db585161c1f8b9438710.svg";
export { ForwardRef as ReactComponent };